/**
 * Spectral Performance — Hover-open nav dropdowns
 * Opens <details> menus on mouseenter, closes on mouseleave.
 * Desktop only (992px+). Does not interfere with mobile drawer.
 */
(function () {
  function init() {
    if (window.innerWidth < 992) return;

    const navItems = document.querySelectorAll(
      '.wbsimplemenuxs li'
    );

    navItems.forEach(function (li) {
      const details = li.querySelector(':scope > details-disclosure > details, :scope > details');
      if (!details) return;

      let closeTimer = null;

      function openMenu() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        details.setAttribute('open', '');
        li.classList.add('sp-nav-hover');
      }

      function closeMenu() {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          li.classList.remove('sp-nav-hover');
          closeTimer = null;
        }, 120); // small delay prevents flicker when moving into dropdown
      }

      li.addEventListener('mouseenter', openMenu);
      li.addEventListener('mouseleave', closeMenu);

      // Keep open when cursor moves into the dropdown panel itself
      const panel = details.querySelector('div[id^="HeaderMenu-MenuList"]');
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        });
        panel.addEventListener('mouseleave', closeMenu);
      }
    });
  }

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on resize in case user resizes to desktop
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();
